import { createStore } from 'effector';
import { FeatureModel } from './entitres';

export const $features = createStore<FeatureModel[]>([]);
